(function () {

  function getUTMSource() {
    const params = new URLSearchParams(window.location.search);
    return params.get('utm_source');
  }

  function isPaidSource(source) {
    if (!source) return false;

    const s = source.toLowerCase();

    // PPC sources (as per your platforms)
    return s.includes('google') || 
           s.includes('meta') || 
           s.includes('facebook') || 
           s.includes('instagram') || 
           s.includes('bing') || 
           s.includes('microsoft');
  }

  const source = getUTMSource();

  if (isPaidSource(source)) {
    document.documentElement.classList.add('is-ppc');
  } else {
    document.documentElement.classList.add('is-organic');
  }

})();